import Vue from 'vue';
import Router from 'vue-router';
import { authUrl, logoutUrl, createApi } from '@/utils';

Vue.use(Router);

const ifAuthenticated = (to, from, next) => {
  if (localStorage.getItem('token')) {
    next();
    return;
  }
  next('/login');
};

const ifNotAuthenticated = (to, from, next) => {
  if (!localStorage.getItem('token')) {
    window.location.href = authUrl;

    next();
    return;
  }
  next('/');
};

const beforeEnterlogout = (to, from, next) => {
  if (localStorage.getItem('token')) {
    const idToken = localStorage.getItem('idToken');
    localStorage.removeItem('token');
    localStorage.removeItem('idToken');

    window.location.href = logoutUrl(idToken);
    next();

    return;
  }
  next('/login');
};


export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      beforeEnter(to, from, next) {
        ifNotAuthenticated(to, from, next);
      },
      name: 'login',
    },
    {
      path: '/logout',
      beforeEnter(to, from, next) {
        beforeEnterlogout(to, from, next);
      },
      name: 'logout',
    },
    {
      path: '/callback',
      name: 'callback',
      beforeEnter(to, from, next) {
        const parsedParams = {};
        to.hash.split('&').map(part => part.replace(/#/, '')).forEach((param) => {
          const parts = param.split('=');
          // eslint-disable-next-line prefer-destructuring
          parsedParams[parts[0]] = parts[1];
        });

        if (parsedParams.error && parsedParams.error === 'access_denied') {
          next('/login');
          return;
        }

        if (parsedParams.access_token) {
          localStorage.setItem('token', parsedParams.access_token);
        }

        if (parsedParams.id_token) {
          localStorage.setItem('idToken', parsedParams.id_token);
        }

        createApi();

        if (localStorage.getItem('token') && localStorage.getItem('idToken')) {
          next('/');
        } else {
          next('/login');
        }
      },
    },
    // ----- END LOGIN ---------
    {
      path: '/dossier-overview',
      name: 'dossier-overview',
      component: () => import('./views/DossierOverview/DossierOverview.vue'),
      alias: '/',
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/input-form',
      name: 'input-form',
      component: () => import('./views/InputForm/InputForm.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/input-form/:id',
      name: 'input-form-with-id',
      component: () => import('./views/InputForm/InputForm.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/product-overview',
      name: 'product-overview',
      component: () => import('./views/Product/ProductOverview/ProductOverview.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/product',
      name: 'product',
      component: () => import('./views/Product/ProductDetail/ProductDetail.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/product/:id',
      name: 'product-with-id',
      component: () => import('./views/Product/ProductDetail/ProductDetail.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/unlinked-input-overview',
      name: 'unlinked-input-overview',
      component: () => import('./views/UnlinkedInputOverview/UnlinkedInputOverview.vue'),
      alias: '/',
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/stakeholder-overview',
      name: 'stakeholder-overview',
      component: () => import('./views/Stakeholder/StakeholderOverview/StakeholderOverview.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/stakeholder',
      name: 'stakeholder',
      component: () => import('./views/Stakeholder/StakeholderDetail/StakeholderDetail.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/stakeholder/:id',
      name: 'stakeholder-with-id',
      component: () => import('./views/Stakeholder/StakeholderDetail/StakeholderDetail.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/matches',
      name: 'matches',
      component: () => import('./views/Matches/MatchesOverview.vue'),
      beforeEnter: ifAuthenticated,
    },
  ],
});
